
import React from 'react';
import { motion } from 'framer-motion';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';

const FeatureCard = ({ 
  icon, 
  title, 
  description, 
  buttonText, 
  buttonLink, 
  gradient, 
  delay = 0,
  className = "",
  ...props 
}) => {
  const fadeIn = (delay = 0, y = 20) => ({ 
    hidden: { opacity: 0, y: y, scale: 0.98 },
    visible: { opacity: 1, y: 0, scale: 1, transition: { duration: 0.7, delay, ease: [0.6, -0.05, 0.01, 0.99] } },
  });

  return (
    <motion.div 
      variants={fadeIn(delay, 15)}
      initial="hidden"
      animate="visible"
      className={`glassmorphism-card bg-gradient-to-br ${gradient} p-6 rounded-2xl shadow-xl hover:shadow-2xl transition-all duration-300 flex flex-col items-center text-center h-full ${className}`}
      whileHover={{ y: -8, scale: 1.02 }}
      {...props}
    >
      <div className="flex justify-center items-center mb-4 w-16 h-16 bg-gradient-to-br from-white/80 to-white/60 rounded-full shadow-md">
        {icon}
      </div>
      <h3 className="text-xl font-heading font-medium text-cm-blue-dark mb-3">{title}</h3>
      <p className="text-cm-gray text-sm leading-relaxed flex-grow mb-4">{description}</p>
      {buttonText && buttonLink && (
        <Button asChild variant="outline" className="glassmorphism-button text-cm-blue-dark border-cm-blue hover:text-cm-pink hover:border-cm-pink font-medium px-6 py-3 rounded-xl transform hover:scale-105 transition-all duration-300">
          <Link to={buttonLink}>
            {buttonText}
          </Link>
        </Button>
      )}
    </motion.div>
  );
};

export default FeatureCard;
